import React from 'react';
import { Check, Gift, Zap } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
const freeBonuses = ['50 ejercicios mentales para runners de menos de 3 minutos.', 'Protocolos mentales para 5K, 10K, 21K y 42K.', 'Diario del corredor: registro mental y emocional de 90 días.', '100 frases de autodiálogo para momentos difíciles durante una carrera.', 'Cómo manejar la ansiedad previa a una competición.'];
export function Pricing() {
  return <section id="oferta" className="py-8 px-4 md:px-8 bg-ink text-white" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        {/* Attention badge */}
        <div className="flex justify-center mb-4" data-id="element-92">
          <span className="inline-flex items-center gap-2 bg-red-500 text-white font-display font-bold text-sm md:text-base uppercase tracking-wider py-2 px-5 rounded-full shadow-lg animate-pulse" data-id="element-93">
            <Zap className="w-4 h-4 fill-white" data-id="element-94" />
            Solo por hoy
          </span>
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl relative overflow-hidden ring-4 ring-sage/40" data-id="element-95">
          <div className="absolute top-0 left-0 w-full h-2 bg-forest" data-id="element-96" />

          <h2 className="font-display md:text-6xl text-ink text-center mb-2 tracking-tight text-[36px] font-[800]" data-id="element-97">
            ¡OFERTA SOLO POR HOY! 🎁
          </h2>
          <p className="text-center text-forest font-semibold mb-5" data-id="element-98">
            Aprovechá antes de que vuelva al precio normal
          </p>

          {/* Price */}
          <div className="flex flex-col items-center justify-center gap-1 mb-5" data-id="element-99">
            <p className="text-lg text-ink/50 font-medium" data-id="element-100">Antes</p>
            <p className="text-3xl text-ink/40 line-through font-display font-bold" data-id="element-101">
              $49.990
            </p>
            <p className="text-xl text-forest font-bold mt-3" data-id="element-102">Hoy</p>
            <p className="text-6xl md:text-8xl font-display font-black text-forest leading-none" data-id="element-103">
              $19.990
            </p>
            <p className="text-sm text-ink/50 mt-2" data-id="element-104">
              Pesos Argentinos · Pago único
            </p>
          </div>

          {/* Countdown */}
          <div className="bg-sage-soft rounded-2xl py-4 px-4 mb-5" data-id="element-105">
            <p className="text-center text-ink/70 font-semibold uppercase text-sm tracking-wider mb-1" data-id="element-106">
              🔥 La oferta termina en
            </p>
            <CountdownTimer data-id="element-107" />
          </div>

          {/* Free bonuses */}
          <div className="bg-sage-soft border border-sage/40 rounded-2xl p-6 mb-5 text-left" data-id="element-108">
            <div className="flex items-center gap-2 mb-4" data-id="element-109">
              <Gift className="w-6 h-6 text-forest" data-id="element-110" />
              <h3 className="font-display font-bold text-lg md:text-xl text-ink" data-id="element-111">
                Además, hoy te llevás GRATIS:
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-112">
              {freeBonuses.map((bonus, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-113">
                  <span className="flex-shrink-0 w-5 h-5 mt-0.5 bg-forest rounded-full flex items-center justify-center" data-id="element-114">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-115" />
                  </span>
                  <span className="text-ink/80 font-medium" data-id="element-116">{bonus}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center" data-id="element-117">
            <CTAButton className="w-full md:w-auto text-xl py-5 px-10" data-id="element-118" />
          </div>

          <p className="mt-6 text-sm text-ink/50 flex items-center justify-center gap-2" data-id="element-119">
            🔒 Pago 100% seguro y encriptado · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}